<template>
  <a
    class="ss__coCreationEntry__card__wrapper"
    :href="item.url"
    :target="item.blank ? '_blank' : '_self'">
    <div
      class="ss__coCreationEntry__card"
      :style="{ '--image-SsCoCreationEntryCard-bg': `url(${item.image})` }">
      <i class="ssCommunityIcon__puzzle" />
      <span class="ss__coCreationEntry__title">少数派共创中心</span>
      <span class="ss__coCreationEntry__desc">浏览全部项目，参与或发起共创</span>
      <SsButton2 class="ss__coCreationEntry__btn"><span>进入</span></SsButton2>
    </div>
  </a>
</template>

<script>
import SsButton2 from '../SsButton2'
export default {
  name: 'SsCoCreationEntryCard',

  components: {
    SsButton2
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'
.ss__coCreationEntry__card__wrapper {
  display: block;
  width: 100%;
  @media (min-width: $screen-lg) {
    height: 366px;
  }
}
.ss__coCreationEntry__card {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25.5px 16px;
  background-image: var(--image-SsCoCreationEntryCard-bg);
  background-size: cover;
  color: #fff;
  border-radius: 16px;
  outline: 1px solid var(--color-imageBorder, #0000000D)!important;
  .ssCommunityIcon__puzzle {
    font-size: 76px;
    background linear-gradient(180deg, #FFFFFF 27%, rgba(255, 255, 255, 0.8) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .ss__coCreationEntry__title {
    margin-top: 16px;
    font-size: 15px;
    font-weight: 500;
  }
  .ss__coCreationEntry__desc {
    font-size: 13px;
    opacity: 0.6;
    margin-top: 4px;
  }
  .ss__coCreationEntry__btn {
    width: 42px;
    height: 26px;
    background: #FFFFFF1A;
    border-radius: 6px;
    margin-top: 24px;
    font-size: 13px;
    font-weight: 500;
    color: #fff;
  }
}
</style>
